import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Typography, Icon, Tooltip, message, Popconfirm } from 'antd'
import { getLocalData } from "../../../../services/StorageServices"
import EditPartnerModal from '../add/EditPartnerModal'
import { deletePartner, unHidePartner } from '../../../../services/api/3dApi'
import { canManagePartner, getNoPermissionMessage, getPartnerErrorMessage, DISABLED_ICON_STYLE } from '../../helpers/partnerPermission'

const { Paragraph } = Typography

class ColActions extends Component {

    _handleDeletePartner = async (id) => {
        try {
            const { item, reset } = this.props
            const { data } = await deletePartner(id)
            const { success, error } = data

            if (!success) throw new Error(error)

            message.success(<span>Xóa đối tác <b>{item.name}</b> thành công.</span>)
            reset()
        } catch (error) {
            message.error(getPartnerErrorMessage(error, 'xoá'))
        }
    }

    _handleUnhidePartner = async (id) => {
        try {
            const { item, reset } = this.props
            const { data } = await unHidePartner(id)
            const { success, error } = data

            if (!success) throw new Error(error)

            message.success(<span>Hiện đối tác <b>{item.name}</b> thành công.</span>)
            reset()
        } catch (error) {
            message.error(getPartnerErrorMessage(error, 'hiện lại'))
        }
    }

    render() {
        const { code, partnerURL, reset, item } = this.props
        const accessToken = getLocalData('accessToken')
        const refreshToken = getLocalData('refreshToken')
        const url = [
            `${partnerURL}/${code}`,
            [accessToken && `token=${accessToken}`, refreshToken && `refresh_token=${refreshToken}`].filter(Boolean).join('&')
        ].filter(Boolean).join('?')
        const canManage = canManagePartner()

        return <td className="colActions">
            <div className="d-flex align-items-center">
                <EditPartnerModal reset={reset} item={item} />
                <Paragraph copyable={{ text: url }} className='mb-0 mr-2' />
                <div className='viewPartner Icon mr-2 cursor-pointer' onClick={() => window.open(url, "_blank")}>
                    <Tooltip placement="top" title="Xem">
                        <Icon className="text-success" type="eye" />
                    </Tooltip>
                </div>
                <Tooltip title={canManage ? 'Xóa đối tác' : getNoPermissionMessage('xoá')} className='mr-2'>
                    <Popconfirm
                        title="Bạn chắc chắn muốn xóa đối tác này?"
                        onConfirm={() => this._handleDeletePartner(item._id)}
                        okText="Có"
                        cancelText="Không"
                        disabled={!canManage}
                    >
                        <span>
                            <i
                                className={`fa fa-trash ${canManage ? 'text-danger cursor-pointer' : 'text-muted'}`}
                                style={canManage ? { fontSize: 17 } : { fontSize: 17, ...DISABLED_ICON_STYLE }}
                            />
                        </span>
                    </Popconfirm>
                </Tooltip>
                {
                    item.hidden &&
                    <Tooltip title={canManage ? 'Hiện đối tác' : getNoPermissionMessage('hiện lại')} className='mr-2'>
                        <Popconfirm
                            title="Bạn chắc chắn muốn hiện đối tác này?"
                            onConfirm={() => this._handleUnhidePartner(item._id)}
                            okText="Có"
                            cancelText="Không"
                            disabled={!canManage}
                        >
                            <span className={canManage ? 'cursor-pointer' : ''} style={canManage ? undefined : DISABLED_ICON_STYLE}>
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="11" cy="6" r="4" stroke="#1C274C" stroke-width="1.5"/>
                                    <path d="M17 10.3C17.5207 10.7686 17.8126 11.0314 18.3333 11.5L21 8.5" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18.9975 18C19 17.8358 19 17.669 19 17.5C19 15.0147 15.4183 13 11 13C6.58172 13 3 15.0147 3 17.5C3 19.9853 3 22 11 22C13.231 22 14.8398 21.8433 16 21.5634" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </span>
                        </Popconfirm>
                    </Tooltip>
                }
            </div>
        </td>
    }
}

ColActions.propTypes = {
    code: PropTypes.string.isRequired,
    partnerURL: PropTypes.string,
}

export default ColActions